import { Component } from 'react';
import PropTypes from 'prop-types';

import { stringToQuery } from 'utils/url';

export default class EnforceLocation extends Component {
  static propTypes = {
    href: PropTypes.string.isRequired,
    location: PropTypes.object, // injected by react-router
    router: PropTypes.shape({
      replace: PropTypes.func.isRequired,
      createLocation: PropTypes.func.isRequired,
    }),
    onLocationChange: PropTypes.func,
  };

  componentDidMount() {
    this.updateLocationIfRequired();
  }

  shouldComponentUpdate(nextProps) {
    return this.props.href !== nextProps.href || nextProps.href.split('?')[0] !== window.location.pathname;
  }

  componentDidUpdate() {
    this.updateLocationIfRequired();
  }

  updateLocationIfRequired() {
    if (this.shouldChangeLocation()) {
      const { router, onLocationChange } = this.props;
      const newLocation = this.createNewLocationWithState();

      if (typeof onLocationChange === 'function') {
        onLocationChange({ ...newLocation });
      }

      router.replace(newLocation);
    }
  }

  shouldChangeLocation() {
    const { href, location } = this.props;
    if (!location) {
      // running as unit test, skip changing the location
      return false;
    }

    const currentState = location.state || {};
    if (location.state && currentState.key && location.key !== currentState.key) {
      // different location key, probably new route is already loading, do not change the location
      return false;
    }

    const currentHref = `${location.pathname}${location.search}`;
    if (href === currentHref) {
      // location already valid
      return false;
    }

    if (currentState.originalLocation && href === currentState.originalLocation) {
      // prevent updating the location over and over, which could happen if there is more then one <EnforceLocation /> component instance
      // being used with different href requested, or the href value changes for a single route
      // eslint-disable-next-line max-len
      throw new Error(`Location already enforced from ${currentState.originalLocation} to ${currentHref}, may be done only once for the route.`);
    }

    return true;
  }

  createNewLocationWithState() {
    const { href, location: originalLocation, router } = this.props;

    const originalLocationQuery = stringToQuery(originalLocation.search); // can contain whitelisted tags
    const newLocation = router.createLocation(href); // contains slugified skus and categories - does not contain whitelisted tags

    // we need to merge queries of the above to preserve whitelisted tags
    newLocation.query = {
      ...originalLocationQuery,
      ...newLocation.query,
    };

    const currentState = originalLocation.state || { key: null };

    return {
      ...newLocation,
      state: {
        ...currentState,
        // we need to remember the original location so we do not get into loop
        originalLocation: `${originalLocation.pathname}${originalLocation.search}`, // no hash as yet
      },
    };
  }

  render() {
    return null; // no visual representation
  }
}
